import { ContractDetailsSolicitor } from "../features/contract/contract-details/contract-details-solicitor";

const Assigncontract = () => {
  return <ContractDetailsSolicitor />;
};

export default Assigncontract;
